import { createSlice } from "@reduxjs/toolkit";

const accountUsersSlice = createSlice({
    name: "accountUsers",
    initialState: {
        accountId: null,
        lastFetched: null,
        users: [],
        serviceUsers: [],
        serviceUsersStatus: 'idle',
    },
    reducers: {
        getUser() { },
        getManagers() { },
        getAllUsers() { },
        createUser() { },
        updateUser() { },
        uploadUserAvatar() { },
        removeUserAvatar() { },
        updateUserPassword() { },
        activateUser() { },
        deactivateUser() { },
        getDeactivationImpact() { },
        deleteUser() { },
        restoreUser() { },
        addUserAccounts() { },
        updateUserAccountRole() { },
        removeUserAccounts() { },
        updateUserRole() { },
        updateUserEmail() { },
        getUserAccessFlags() { },
        setUserApiAccess() { },
        fetchAccountUsers() { },
        fetchUserAssignments() { },
        fetchMentionableServiceUsers(state) { state.serviceUsersStatus = 'loading'; },
        updatePinnedAccounts() { },
        toggleStarredItem() { },
        setAccountId(state, action) {
            const accountId = action.payload;
            return { ...state, accountId: accountId };
        },
        usersReceived(state, action) {
            const users = action.payload;
            return { ...state, users: users };
        },
        serviceUsersReceived(state, action) {
            return { ...state, serviceUsers: action.payload || [], serviceUsersStatus: 'loaded' };
        },
    },
});

export const { fetchAccountUsers, fetchMentionableServiceUsers, setAccountId, usersReceived, serviceUsersReceived, getUser, getManagers, getAllUsers, createUser, updateUser, uploadUserAvatar, removeUserAvatar, updateUserPassword, activateUser, deactivateUser, getDeactivationImpact, deleteUser, restoreUser, addUserAccounts, updateUserAccountRole, removeUserAccounts, updateUserRole, updateUserEmail, getUserAccessFlags, setUserApiAccess, fetchUserAssignments, updatePinnedAccounts, toggleStarredItem, setPinnedAccounts } = accountUsersSlice.actions;
export default accountUsersSlice.reducer;